import React from "react";
import { getFullName } from "../../../components/util/helpers";
import { useIntl } from "react-intl";
import { IonLabel, IonItem, IonAvatar, IonBadge } from "@ionic/react";
import { ReactComponent as AvatarImg } from "../../../assets/avatar.svg";
import { Img } from "react-image";
import moment from "moment";

const SchedulingItem = (props) => {
  const { item } = props;
  const intl = useIntl();
  const startDate = moment(item.date).format("HH:mm");
  var endDate = moment(item.date)
    .add(item.duration_minutes, "minutes")
    .format("HH:mm");

  const timeframe = startDate + "-" + endDate;

  return (
    <IonItem key={item.id}>
      <IonAvatar slot="start">
        {item.employee && item.employee.avatar_url ? (
          <Img
            src={[item.employee.avatar_url]}
            unloader={<AvatarImg style={{ borderRadius: "50%" }} />}
          />
        ) : (
          <AvatarImg style={{ borderRadius: "50%" }} />
        )}
      </IonAvatar>
      <div style={{ padding: "6px 0" }}>
        <IonLabel>
          {item.employee &&
            item.employee.first_name &&
            `${getFullName(item.employee.surename, item.employee.first_name)}`}
        </IonLabel>

        <IonLabel color="medium">
          {`${timeframe} - ${item.client_name}`}
        </IonLabel>
      </div>
      {moment().day() === item.weekday && (
        <IonBadge color="success" slot="end">
          {intl.formatMessage({
            id: "app.mobile.today",
          })}
        </IonBadge>
      )}
    </IonItem>
  );
};

export default SchedulingItem;
